<template>
    <section class="search-all-components col-md-12">
        <div class="row">
            <div class="col-lg-9 col-md-9 col-xs-12 components-list">
                <div class="components-list-items">
                    <loader :position="'fixed'" :spinLeft="'60%'" :loading="loader"></loader>
                    <div class="all-component row" v-for="(type, index) in getComponent" :key="index" v-if="type.data.length">
                        <div class="col-lg-12 components-title">
                            <h3>{{ type.numItems }} {{ getTranslate(type.terms.name) }}</h3>
                        </div>
                        <div
                            class="list-components col-lg-3 col-md-3 col-xs-6"
                            v-for="(item, index) in type.data.slice(0, 4)"
                            :key="index"
                            @mouseenter.prevent.stop="hoverIndex = `${type.type}_${index}`;"
                            @mouseleave.prevent.stop="hoverIndex = null;"
                            :class="{ 'hover-active': hoverIndex === `${type.type}_${index}` }"
                        >
                            <div style="position: relative">
                                <div>
                                    <router-link
                                        v-if="type.type !== 'shade'"
                                        tag="a"
                                        :to="'/' + type.name + '/' + item.id + '?refere=all-components'"
                                    >
                                        <ComponentPreview :component="mergeComponentWithType(type, item)"></ComponentPreview>
                                    </router-link>
                                    <figure v-if="type.type === 'shade'" class="list-components-figure figure-shade">
                                        <router-link tag="a" :to="'/product/' + item.component.id + '?refere=all-components'">
                                            <img
                                                src="../../../static/img/no_image.jpg"
                                                class="grab img-fluid ff-medium svgMeuble center"
                                                v-if="item.component.figures && !item.component.figures.small"
                                            />
                                            <img
                                                :src="getImgPath(item.component.figures.small)"
                                                v-if="item.component.figures && item.component.figures.small"
                                            />
                                        </router-link>
                                    </figure>
                                    <div v-if="hoverIndex === `${type.type}_${index}`" class="forecast-button">
                                        <span
                                            @click.prevent.stop="
                                                forecastItem = item;
                                                displayForecastModal = true;
                                            "
                                            class="basket iLineBlock"
                                            v-if="canAddToForecast() && hasAccessDelete(forecastFunctionality)"
                                            @mouseenter.prevent.stop="hoverIndexForecast = `${type.type}_${index}`;"
                                            @mouseleave.prevent.stop="hoverIndexForecast = null;"
                                        >
                                            <ForecastIcon style="height: 20px; margin-bottom: -2px" />
                                        </span>
                                        <div :style="{ visibility: hoverIndexForecast === `${type.type}_${index}` ? 'visible' : 'hidden' }">
                                            Add to forecast
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="type.type === 'shade'"
                                class="bgColor"
                                :style="item.properties.colors ? { 'background-color': item.properties.colors.color.value } : ''"
                            >
                                <i v-if="!item.properties.colors" class="far fa-empty-set"></i>
                            </div>
                            <div class="typeDetail">
                                <h3 v-if="type.type !== 'shade'">{{ getTranslate(item.terms.name) }}</h3>
                                <h3 v-if="type.type === 'shade'">{{ getTranslate(item.component.terms.name) }}</h3>
                                <p class="refProduct" v-if="type.type === 'shade'">
                                    <span v-if="item.properties.number">{{ item.properties.number.numb1.value }}</span>
                                    <span>- {{ item.terms.name ? getTranslate(item.terms.name) : item.name }}</span>
                                    <span class="block">({{ item.properties.reference.client_ref1.value }})</span>
                                </p>
                                <p class="refProduct" v-if="type.type !== 'shade'">
                                    <span v-if="item.infosArticle.client_ref1">{{ item.infosArticle.client_ref1.componentProperty.value }} -</span>
                                    <span v-if="item.infosArticle.diam_ref1">{{ item.infosArticle.diam_ref1.componentProperty.value }}</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="type.data.length > 4" class="btn-next">
                            <router-link
                                v-if="type.type !== 'shade'"
                                tag="a"
                                :to="'/catalog?&offset=1&type=' + type.type + '&search=' + $route.query.search + '&refere=all-components'"
                            >
                                <i class="fas fa-chevron-right fa-4x"></i>
                            </router-link>
                            <router-link
                                v-if="type.type === 'shade'"
                                tag="a"
                                :to="'/shades?&offset=1&type=' + type.type + '&search=' + $route.query.search + '&refere=all-components'"
                            >
                                <i class="fas fa-chevron-right fa-4x"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ForecastItemModal v-if="displayForecastModal" :item="forecastItem" @close="displayForecastModal = false;" />
    </section>
</template>

<script>
import ComponentPreview from "@/catalog/component-preview";
import { mapActions, mapGetters } from "vuex";
import Globals from "../globals.js";
import loader from "../loader/loader";
import ForecastItemModal from "@/components/forecasts/elements/catalogue/Modal";
import ForecastIcon from "@/components/forecasts/elements/icons/ForecastIcon";
import { FUNCTIONALITY as forecastFunctionality } from "@/components/forecasts/constants";
import { canAddItemToAtLeastOneForecast } from "@/components/forecasts/validation/forecastValidator";

export default {
    components: { loader, ComponentPreview, ForecastItemModal, ForecastIcon },
    data: () => ({
        listeComponent: "",
        loader: true,
        displayForecastModal: false,
        displayForecast: false,
        forecastFunctionality,
        forecastItem: null,
        hoverIndex: null,
        hoverIndexForecast: null
    }),
    created() {
        this.getComponentAction(this.$route.query.search).then(() => {
            this.listeComponent = Object.values(this.getComponent);
            this.loader = false;
        });
    },
    watch: {
        $route(to, from) {
            this.loader = true;
            this.getComponentAction(to.query.search).then(() => {
                this.loader = false;
            });
        }
    },
    methods: {
        ...mapActions({
            getComponentAction: "component/getComponentAction"
        }),
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        },
        mergeComponentWithType(type, component) {
            return { type: type.name, ...component };
        },
        canAddToForecast() {
            return canAddItemToAtLeastOneForecast(this.forecasts, this.item);
        }
    },
    computed: {
        ...mapGetters({
            getComponent: "component/getComponent"
        }),
        hasForecastAccess() {
            return this.hasAccessDelete(forecastFunctionality);
        }
    }
};
</script>

<style scoped lang="scss">
@import "./../../assets/css/themes";
.search-all-components {
    .components-searchBar-menu {
        background: white;
        padding: 25px;
        .dark & {
            background-color: #111111;
            border: 1px #686868 solid;
        }
    }
    .list-components {
        /*border-right: 1px solid #ccc;*/
        text-align: center;
        margin-bottom: 25px;
        font-family: "oswald-regular", sans-serif;
        font-size: 14px;
        &:nth-child(5) {
            border-right: none;
        }
        &-figure {
            border: 1px solid #ccc;
            background: white;
            img {
                max-height: 200px;
                max-width: 100%;
                &:hover {
                    opacity: 0.5;
                }
            }
        }
        .typeDetail {
            .dark & {
                color: #e8e8e8;
            }
            h3 {
                margin: 5px 0;
            }
            .refProduct {
                margin: 0;
            }
        }
        .bgColor {
            height: 20px;
            border: 1px solid #ccc;
            border-top: none;
        }
    }
    .components-list {
        &-items {
            background: white;
            padding: 25px;
            .dark & {
                background-color: #111111;
                border: 1px #686868 solid;
            }
            .all-component {
                position: relative;
                .components-title {
                    h3 {
                        color: $color2;
                        text-transform: uppercase;
                        text-align: left;
                        font-size: 16px;
                        font-weight: bold;
                        font-family: "oswald-regular", sans-serif;
                    }
                }
            }
        }
        .btn-next {
            position: absolute;
            right: 5px;
            top: 40%;
            background: white;
            color: $color2;
            .dark & {
                background: #111111;
            }
            svg {
                color: $color2;
            }
        }
    }
    .forecast-button {
        left: 50%;
        top: 90%;
        transform: translate(-50%, -90%);
        position: absolute;
        z-index: 2;
        cursor: pointer;
        padding: 7px;
        background-color: #ffffff;
    }
}
</style>



// WEBPACK FOOTER //
// SearchAllComponents.vue?b1456418